/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {LogRequest} from "../model/log-request";

@Injectable({
    providedIn: "root",
})
export class SimLogService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public downloadLogsFiles_Url() {
        return super.getUrl(`/api/Log/DownloadLogsFiles`, );
    }

    public logError(request: LogRequest) {
        return super.post<void>(`/api/Log/LogError`, request);
    }

    public logInfo(request: LogRequest) {
        return super.post<void>(`/api/Log/LogInfo`, request);
    }

    public logWarn(request: LogRequest) {
        return super.post<void>(`/api/Log/LogWarn`, request);
    }
}